// extracted by mini-css-extract-plugin
export default {"btn_submit":"FormInput_btn_submit__1qDSZ","file-upload":"FormInput_file-upload__QR+DB","upload":"FormInput_upload__CLHCi"};